import colors from '../../../styles/colors';

import {
  STORY_CENTER_X,
  STORY_HEIGHT,
  STORY_WIDTH,
  drawRotated,
  drawWithShadow,
} from './canvasDrawing';
import getStoryPalette from './palette';
import { STICKER_HEIGHT, STICKER_WIDTH } from './stickerFrames';

// Room around the sticker for the parts that stick out, like the polaroid's tape.
const STICKER_MARGIN = 24;
const STICKER_CANVAS_WIDTH = STICKER_WIDTH + STICKER_MARGIN * 2;
const STICKER_CANVAS_HEIGHT = STICKER_HEIGHT + STICKER_MARGIN * 2;

const STORY_STICKER_WIDTH = 860;

/**
 * Draws the sticker alone, on a transparent canvas of STICKER_CANVAS_WIDTH × STICKER_CANVAS_HEIGHT units.
 *
 * @param {CanvasRenderingContext2D} ctx A context already scaled to the size wanted.
 * @param {Object} scene
 * @param {import('./shareCard').ShareCard} scene.card
 * @param {{ draw: Function }} scene.frame One of the sticker frames.
 * @param {?CanvasImageSource} scene.photo The client's photo, already filtered, or null before they add one.
 * @param {Date} scene.now
 */
const renderSticker = (ctx, {
  card,
  frame,
  photo,
  now,
}) => {
  ctx.save();
  ctx.translate(STICKER_MARGIN, STICKER_MARGIN);
  frame.draw(ctx, {
    card,
    photo,
    palette: getStoryPalette(card),
    now,
  });
  ctx.restore();
};

/**
 * Draws a whole 1080 × 1920 story: the coach's page color with a glow of their color, and the sticker in the
 * middle, clear of the top and bottom ~14% where Instagram draws its own controls.
 *
 * @param {CanvasRenderingContext2D} ctx A context on a 1080 × 1920 canvas.
 * @param {Object} scene
 * @param {import('./shareCard').ShareCard} scene.card
 * @param {CanvasImageSource} scene.sticker The sticker, as renderSticker drew it.
 */
const renderStory = (ctx, { card, sticker }) => {
  const palette = getStoryPalette(card);
  const centerY = STORY_HEIGHT / 2;
  ctx.fillStyle = palette.background;
  ctx.fillRect(0, 0, STORY_WIDTH, STORY_HEIGHT);
  const glow = ctx.createRadialGradient(STORY_CENTER_X, centerY, 0, STORY_CENTER_X, centerY, STORY_HEIGHT / 2);
  glow.addColorStop(0, colors.addAlpha(palette.accent, 0.28));
  glow.addColorStop(1, colors.addAlpha(palette.accent, 0));
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, STORY_WIDTH, STORY_HEIGHT);

  const width = STORY_STICKER_WIDTH;
  const height = (width * STICKER_CANVAS_HEIGHT) / STICKER_CANVAS_WIDTH;
  drawRotated(ctx, { x: STORY_CENTER_X, y: centerY, degrees: -3 }, () => {
    drawWithShadow(ctx, () => ctx.drawImage(sticker, STORY_CENTER_X - width / 2, centerY - height / 2, width, height));
  });
};

export {
  STICKER_MARGIN,
  STICKER_CANVAS_WIDTH,
  STICKER_CANVAS_HEIGHT,
  renderSticker,
  renderStory,
};
